/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Footer, Header, HeaderMobile, Preloader } from "./components";
import { Main, RequireAuth } from "./container";
import {
  About,
  Cart,
  Checkout,
  Compare,
  ContactUs,
  Home,
  Invoice2,
  Login,
  MemebersPage,
  MyAccount,
  Page404,
  PrivacyPolicy,
  ProductDetail,
  Register,
  Shop2,
  Wishlist,
} from "./pages";
import { Routes, Route } from "react-router-dom";
import { useDeliveryCharges, useStore } from "./redux/hooks";

const App = () => {
  const deliveryCharge = useDeliveryCharges();
  const store = useStore();
  useEffect(() => {
    (async () => {
      if (!deliveryCharge.isLoaded) {
        await deliveryCharge.getDeliveryCharges();
      }
    })();
  }, [deliveryCharge.isLoaded]);

  useEffect(() => {
    (async () => {
      await store.findAll();
    })();
  }, []);

  useEffect(() => {
    // Inject the Facebook Pixel script
    const script = document.createElement("script");
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1386967865775784'); 
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Optional: Add <noscript> fallback for no-JS browsers
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
           src="https://www.facebook.com/tr?id=1386967865775784&ev=PageView&noscript=1"/>
    `;
    document.body.appendChild(noscript);

    // Cleanup if needed (optional)
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);

  return (
    <Main>
      <Header />
      <HeaderMobile />
      <Routes>
        <Route path="/terms-condition" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/checkout"
          element={
            <RequireAuth>
              <Checkout />
            </RequireAuth>
          }
        />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/compare" element={<Compare />} />
        <Route
          path="/invoice/:id"
          element={
            <RequireAuth>
              <Invoice2 />
            </RequireAuth>
          }
        />
        <Route
          path="/my-account"
          element={
            <RequireAuth>
              <MyAccount />
            </RequireAuth>
          }
        />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/shop/product-detail/:id" element={<ProductDetail />} />
        <Route path="/shop" element={<Shop2 />} />
        <Route path="/about" element={<About />} />
        <Route path="/members" element={<MemebersPage />} />
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      <Footer />
      <Preloader />
    </Main>
  );
};

export default App;
